import client from '../client';
import type { ApiResponse } from '../../types/api';

export const currencyApi = {
  /** Convert `amount` from one currency to another (defaults to SAR).
   *  Backed by /api/v1/dashboard/convert-currency, which wraps the same
   *  exchange-rate logic the legacy EJS dashboard used at paylink creation. */
  convert: async (amount: number, fromCurrency: string, toCurrency = 'SAR') => {
    const res = await client.post<ApiResponse<{ amount: number; from: string; to: string }>>(
      '/dashboard/convert-currency',
      { amount, fromCurrency, toCurrency },
    );
    return res.data.data!;
  },
};
